import { callApiToServer } from "../../callApi";

export async function addIP(authtoken, body, id) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Bearer " + authtoken,
    };

    const endUrl = "v1/auth/user/ip";

    const payload = JSON.stringify({
      ip_address: body.ip_address,
      user_id: id,
    });

    const responseData = await callApiToServer(payload, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
